import { gql } from '@apollo/client';

import { ResponsiveImageFragment } from 'approot/shared/graphql/responsive-images/responsive-images.graphql';

export const lessonHeroImageFragment = gql`
  fragment LessonHeroImageFragment on Lesson {
    id
    name
    duration
  }
`;

export const lessonSquareImageFragment = gql`
  fragment LessonSquareImageFragment on Lesson {
    squareImage {
      ...ResponsiveImageFragment
    }
  }
  ${ResponsiveImageFragment}
`;

export const lessonLandscapeImageFragment = gql`
  fragment LessonLandscapeImageFragment on Lesson {
    landscapeImage {
      ...ResponsiveImageFragment
    }
  }
  ${ResponsiveImageFragment}
`;

export const UPDATE_HERO_IMAGE = gql`
  mutation UpdateLessonHeroImage($input: UpdateLessonHeroImageInput!) {
    updateLessonHeroImage(input: $input) {
      ...LessonHeroImageFragment
      ...LessonSquareImageFragment
      ...LessonLandscapeImageFragment
    }
  }
  ${lessonHeroImageFragment}
  ${lessonSquareImageFragment}
  ${lessonLandscapeImageFragment}
`;
